import { createContext } from 'react';
import type { User } from 'firebase/auth';

export interface AuthContextType {
  /** Whether auth has been initialized (Firebase onAuthStateChanged has fired) */
  isLoading: boolean;
  /** Whether a redirect auth flow is being processed (returning from Google sign-in) */
  isRedirecting: boolean;
  /** Whether the user is authenticated (anonymous or linked) */
  isAuthenticated: boolean;
  /** Whether the current user is anonymous (not linked to a permanent account) */
  isAnonymous: boolean;
  /** The Firebase user object, or null if not authenticated */
  user: User | null;
  /** The Firebase user UID, or null if not authenticated */
  uid: string | null;
  /** Link the anonymous account with a Google account for cross-device sync */
  linkWithGoogle: () => Promise<void>;
  /** Sign in with an existing Google account (merges data from anonymous session) */
  signInWithGoogle: () => Promise<void>;
  /** Sign out and create a new anonymous session */
  signOut: () => Promise<void>;
  /** Error message from the last auth operation */
  error: string | null;
}

export const AuthContext = createContext<AuthContextType | undefined>(undefined);
